export const apiBaseUrl = 'https://api.ken42.com/school/stage/pfsportal';
export const tokenUrl = 'https://dev-portal.ken42.com/api/app/azureToken';
export const clientUid = 'vkgi';
export const KEY_ACCESS_TOKEN = 'KEY_ACCESS_TOKEN';
export const KEY_LOGIN_ACCESS_TOKEN = 'login_token';
export const KEY_ACCESS_TOKENS = 'KEY_ACCESS_TOKENS';
export const KEY_REFRESH_TOKEN='refresh_token';
export const REFRESH_URL='https://api-v2.ken42.com/sp-jain/stage/pfs/refreshToken';

export const instituteUrl = 'https://api.ken42.com/schoolstageapp';
export const mailUrl = 'https://api.ken42.com/dev/pfs';
export const configUrl = 'https://config-api.ken42.com/v1/configs/url';
export const adminURL = 'https://api-v2.ken42.com/dev-admin';
export const eventDateFormate = 'MMMM Do YYYY hh:mm a';
export const dateFormate = 'YYYY-MM-DD';
export const dateTimeFormate = 'hh:mm:ss a';
export const examModuleURL = `https://ken426--playground.my.salesforce.com`;
export const ACCESS_TOKEN = 'access_token';
export const INSTITUTE_NAME = 'SP Jain School of Global Management';
export const KEY_USER_DETAILS = 'userDetails';
export const KEY_STATUS = {
  success: 'success',
  failed: 'failed',
  warning: 'Warning',
};
export const KEY_SEVERITY = {
  success: 'success',
  error: 'error',
  warning: 'warning',
  info: 'info',
};

export const KEY_USER = {
  REGEX: {
    NAME: /^[a-zA-Z ]*$/,
    MOBILE: /^(\+\d{1,3}[- ]?)?\d{10}$/,
    NUMBER: /^[0-9]*$/,
    ALPHANUMERIC: /^[a-z0-9]+$/i,
    EMAIL: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/,
  },
};
